import { ChatState } from "../models/meetModal";
import { meetActionTypes } from "../action/action";
import { MessageActions } from "../interface/meetReducerTypes"

const intialState = {
  message: [],
  chatMoreSettings: '',
  chatTrigger: false,
  endAllTrigger: false,
  toParticipant: { conId: "",name:"",deviceid:"" },
  chatmessage: { body: "", fromName: "", conId: "" },
  lockTrigger: false,
  recordTrigger:{ recordPermissionRequest: false, recordPermit:false,name:"",conId: ''},
  isopenChat:false,
  chatConvo:[]
};

export const messageReducer = (state:ChatState=intialState, action:MessageActions) => {

  switch (action.type) {
  case meetActionTypes.ADD_MESSAGE:
    return {
      ...state, message: [...state.message,action.payload.message]
    };

  case meetActionTypes.STORE_CONVERSATION:
    return {
      ...state, message: action.payload.message
    };

  case meetActionTypes.CHAT_MORE_OPTION:
    return {
      ...state,
      chatMoreSettings:action.payload.chatMoreSettings
          
    };
  case meetActionTypes.CHAT_TRIGGER:
    return {
      ...state,
      chatTrigger:action.payload.chatTrigger,chatmessage:action.payload.chatmessage
    };
  case meetActionTypes.END_POPUP_MSG:
    return {
      ...state,
      endAllTrigger:action.payload.endAllTrigger
    };
  case meetActionTypes.CHAT_TO_PARTICIPANTS:
    return {
      ...state,
      toParticipant:action.payload.toParticipant
    };
  case meetActionTypes.LOCK_MEETING_POPUP_MSG:
    return {
      ...state,
      lockTrigger:action.payload.lockTrigger
    };
  case meetActionTypes.RECORD_MEETING_POPUP_MSG:
    return {
      ...state,
      recordTrigger: action.payload.recordTrigger
    };
  case meetActionTypes.CHAT_WINDOW_OPEN:
    return {
      ...state,
      isopenChat: action.payload.isopenChat
    };
    case meetActionTypes.CHAT_RECEIVE_ARRAY:
    return {
      ...state,
      chatConvo: action.payload.chatConvo
    };
  default:
    return state;
  };
};